import { Tag } from '@omnipresentgroup/design-system';
import { toSentenceCase } from '@omnipresentgroup/helpers';
import { CompensationSource } from '@omnipresentgroup/types';

import { COMPENSATION_SOURCE_LABELS } from '../constants';

export const CompensationSourceTag = ({
  source,
}: {
  source: CompensationSource;
}) => {
  const label =
    COMPENSATION_SOURCE_LABELS.get(source) ?? toSentenceCase(source);

  switch (source) {
    case CompensationSource.CONTRACTUAL: {
      return (
        <Tag id="compensation-source-tag-contractual" intent="info">
          {label}
        </Tag>
      );
    }
    case CompensationSource.MONTH_ON_MONTH: {
      return (
        <Tag id="compensation-source-tag-month-on-month" intent="default">
          {label}
        </Tag>
      );
    }
    default: {
      return <Tag id="compensation-source-tag">{label}</Tag>;
    }
  }
};
